export default __webpack_public_path__ + "static/media/terraceparty2020.99e6cca4.jpg";